import * as React from 'react';

var CharacterCount = function (props) {
    var maxLen = props.maxLen, valueLen = props.valueLen, isSkeleton = props.isSkeleton;
    if (isSkeleton) {
        return React.createElement("span", { "data-testid": "character-count-skeleton" }, "\u00A0");
    }
    if (!maxLen || valueLen === undefined) {
        return React.createElement("span", null, "- characters remaining");
    }
    return (React.createElement("span", { "data-testid": "text-input-character-count" },
        maxLen - valueLen,
        "/",
        maxLen,
        " characters remaining"));
};

var textInputStyles = {"group":"TextInput_group_8277561f","control":"TextInput_control_8277561f","focus-visible":"TextInput_focus-visible_8277561f","error":"TextInput_error_8277561f","leftPad":"TextInput_leftPad_8277561f","rightPad":"TextInput_rightPad_8277561f","icon":"TextInput_icon_8277561f","skeleton":"TextInput_skeleton_8277561f","label":"TextInput_label_8277561f","skeletonLabel":"TextInput_skeletonLabel_8277561f","labelText":"TextInput_labelText_8277561f","input":"TextInput_input_8277561f TextInput_control_8277561f","skeletonInput":"TextInput_skeletonInput_8277561f","small":"TextInput_small_8277561f","errorMessage":"TextInput_errorMessage_8277561f","wrapper":"TextInput_wrapper_8277561f","right":"TextInput_right_8277561f","left":"TextInput_left_8277561f","characterCount":"TextInput_characterCount_8277561f","alignRight":"TextInput_alignRight_8277561f","characterCountSkeleton":"TextInput_characterCountSkeleton_8277561f","visuallyHidden":"TextInput_visuallyHidden_8277561f","labelErrorWrapper":"TextInput_labelErrorWrapper_8277561f"};

export { CharacterCount as C, textInputStyles as t };
